import { createSlice } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
}

const initialState: AuthState = {
  token: localStorage.getItem("access_token") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("access_token", action.payload);
    },
    logout: (state) => {
      state.token = null;
      localStorage.removeItem("access_token");
    },
  },
});

export const { setToken, logout } = authSlice.actions;
export default authSlice.reducer;
